<template>
    <section>
        Aqui
    </section>
</template>

<script>

export default {
  name: "top-supplier",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>

</style>
